import { CustomNumberFormatterBaseValueConverter } from 'General/Resources/ValueConverters/CustomNumberFormatterBase';

export class CustomNumberFormatterValueConverter extends CustomNumberFormatterBaseValueConverter {

}